"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generousBookNames = {
    "genesis": "Genesis",
    "exodus": "Exodus",
    "leviticus": "Leviticus",
    "numbers": "Numbers",
    "numeri": "Numbers",
    "deuteronomy": "Deuteronomy",
    "deuteronomium": "Deuteronomy",
    "joshua": "Joshua",
    "josua": "Joshua",
    "judges": "Judges",
    "judices": "Judges",
    "1samuel": "1 Samuel",
    "samueli": "1 Samuel",
    "2samuel": "2 Samuel",
    "samuelii": "2 Samuel",
    "1kings": "1 Kings",
    "1kgs": "1 Kings",
    "regesi": "1 Kings",
    "2kings": "2 Kings",
    "2kgs": "2 Kings",
    "regesii": "2 Kings",
    "isaiah": "Isaiah",
    "jesaia": "Isaiah",
    "jeremiah": "Jeremiah",
    "jeremia": "Jeremiah",
    "ezekiel": "Ezekiel",
    "ezechiel": "Ezekiel",
    "hosea": "Hosea",
    "joel": "Joel",
    "amos": "Amos",
    "obadiah": "Obadiah",
    "jonah": "Jonah",
    "micah": "Micah",
    "micha": "Micah",
    "nahum": "Nahum",
    "habakkuk": "Habakkuk",
    "habakuk": "Habakkuk",
    "zephaniah": "Zephaniah",
    "zephania": "Zephaniah",
    "haggai": "Haggai",
    "zechariah": "Zechariah",
    "sacharia": "Zechariah",
    "malachi": "Malachi",
    "maleachi": "Malachi",
    "psalms": "Psalms",
    "pss": "Psalms",
    "psalmi": "Psalms",
    "iob": "Job",
    "job": "Job",
    "proverbs": "Proverbs",
    "proverbia": "Proverbs",
    "ruth": "Ruth",
    "songofsolomon": "Song of Songs",
    "songsofsolomon": "Song of Songs",
    "songofsongs": "Song of Songs",
    "canticum": "Song of Songs",
    "canticles": "Song of Songs",
    "ecclesiastes": "Ecclesiastes",
    "qoheleth": "Ecclesiastes",
    "lamentations": "Lamentations",
    "threni": "Lamentations",
    "esther": "Esther",
    "daniel": "Daniel",
    "esra": "Ezra",
    "nehemiah": "Nehemiah",
    "1chronicles": "1 Chronicles",
    "chronicai": "1 Chronicles",
    "2chronicles": "2 Chronicles",
    "chronicaii": "2 Chronicles",
    "matthew": "Matthew",
    "mark": "Mark",
    "luke": "Luke",
    "john": "John",
    "jn": "John",
    "acts": "Acts",
    "romans": "Romans",
    "1corinthians": "1 Corinthians",
    "2corinthians": "2 Corinthians",
    "galatians": "Galatians",
    "ephesians": "Ephesians",
    "philippians": "Philippians",
    "colossians": "Colossians",
    "1thessalonians": "1 Thessalonians",
    "2thessalonians": "2 Thessalonians",
    "1timothy": "1 Timothy",
    "2timothy": "2 Timothy",
    "titus": "Titus",
    "philemon": "Philemon",
    "hebrews": "Hebrews",
    "james": "James",
    "1peter": "1 Peter",
    "2peter": "2 Peter",
    "1john": "1 John",
    "2john": "2 John",
    "3john": "3 John",
    "jude": "Jude",
    "revelation": "Revelation"
};
exports.default = generousBookNames;
